import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Label } from 'semantic-ui-react';
import { FilterDropdownStyles } from './styles';

const WorkGroupDropDown = ({
    selectedChart,
    workGroupFilter,
    filterBySelectedWorkGroup,
    idMapping,
    isDrillDownActive,
    isTagFilterApplied,
    title,
}) => {
    return (
        <FilterDropdownStyles>
            <>
                <Label as="label" htmlFor="workGroup">
                    <FormattedMessage id="select_workgroup_dropdown_label" />
                </Label>
                &ensp;
                <select
                    name="workGroup"
                    id="workGroup"
                    value={workGroupFilter}
                    onChange={e => {
                        filterBySelectedWorkGroup(e.target.value);
                    }}
                >
                    <option key={'select'} value={''}>
                        <FormattedMessage id="select_workgroup_dropdown_select_label" /> {title}
                    </option>
                    {idMapping?.map((item: [number, string]) => (
                        <option key={Object.keys(item)[0]} value={Object.keys(item)[0]}>
                            {Object.values(item)[0]}
                        </option>
                    ))}
                </select>
            </>
        </FilterDropdownStyles>
    );
};

export default WorkGroupDropDown;
